import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconAiDocument } from '../../../../../../shared/icon/icon'
import { Form, FormCheckbox, FormSelectListStr, FormSubmitBack, FormTextArea } from '../../../../../../shared/form/form'
import { useApiFormConfig, useApiListConfig } from '../../../../../../api-new/state/ai'
import { Menu, MenuDelete } from '../../../../../../shared/menu/menu'
import { FormRangeFloat } from '../../../../../../shared/form/form-range-float'

export const AiSettings = ({ nodeID }) => {
  const apiFormConfig = useApiFormConfig()
  const apiListConfigModels = useApiListConfig()

  const handleGet = () => {
    apiFormConfig.get(`${nodeID}/node`)
    apiListConfigModels.get('models')
  }

  const hasSettings = useMemo(() => !!apiFormConfig.form.id, [apiFormConfig])

  // A course keeps the model it was saved with, but only models on the
  // server's current list are ever called: a retired one is quietly swapped
  // for the default. Say so here, where it can be fixed.
  const retiredModel = useMemo(() => {
    const saved = apiFormConfig.form.chatModel
    const models = apiListConfigModels.items || []
    return saved && models.length && !models.includes(saved) ? saved : null
  }, [apiFormConfig.form.chatModel, apiListConfigModels.items])

  const handleDeleteSettings = async () => {
    await apiFormConfig.delete(apiFormConfig.form.id)
    await apiFormConfig.get(`${nodeID}/node`)
  }
  // Returned, so a failed save reaches the form, which shows it.
  const handleSubmit = data => (data.id ? apiFormConfig.put(data.id, data) : apiFormConfig.post(data))

  const HeaderMenu = () =>
    <Menu>
      <MenuDelete text="delete custom settings" onClick={handleDeleteSettings} show={hasSettings} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAiDocument} text="settings" onMatch={handleGet}>
        <CardFullHeightScrollY title="AI Settings" HeaderMenu={HeaderMenu}>
          <Form state={apiFormConfig.form} onSubmit={handleSubmit} onRefresh={handleGet}>
            <FormTextArea label="system prompt" name="systemPrompt" rows={6} autoGrow maxRows={24} autoFocus />
            <FormRangeFloat label="temperature" name="temperature" min="0" max="1" step="0.1" />
            <FormCheckbox label="reference documents" name="referenceDocuments" />
            {retiredModel &&
              <div className="alert alert-warning py-2 small mx-1" role="status">
                The model saved for this course, <code>{retiredModel}</code>, is no longer available, so conversations use EducationXR's default model.
                Choose a current model below and update the config.
              </div>}
            <FormSelectListStr label="chat model" name="chatModel" state={apiListConfigModels.items} />
            <FormSubmitBack text="update config" />
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
